import { Card } from '@nike/eds'

interface ConfigSectionProps {
  title: string
  description: string
  isActive: boolean
  value: string | number
  unit?: string
}
  
export const ConfigSection = ({ title, description, isActive, value, unit = '' }: ConfigSectionProps) => {
  return (
    <Card className="!bg-gray-50 !border !border-gray-200">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
        <span className={`px-3 py-1 text-xs font-medium rounded-full ${isActive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
          {isActive ? 'Active' : 'Inactive'}
        </span>
      </div>
      
      <div className="flex-1 items-center gap-4">
        <p className="text-sm text-gray-600 mb-2">
          {description}
        </p>
        <div className={`text-2xl font-bold ${isActive ? 'text-gray-900' : 'text-gray-400'}`}>
          {isActive ? `${value}${unit}` : ''}
        </div>
      </div>
    </Card>
  )
}
